import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import SmoothScroll from '@/components/SmoothScroll';
import { AuthProvider } from '@/context/AuthContext';
import Home from '@/pages/Home';
import Admin from '@/pages/Admin';
import Login from '@/pages/Login';

function App() {
  return (
    <SmoothScroll>
      <div className="App bg-ink-950 min-h-screen text-white">
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            className: '!bg-ink-900 !border !border-white/10 !text-white !rounded-none !font-sans',
            style: {
              borderRadius: 0,
              background: '#091425',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.1)',
              fontFamily: 'Manrope, sans-serif',
            },
          }}
        />
      </div>
    </SmoothScroll>
  );
}

export default App;
